export default "__VITE_ASSET__DJF5k4La__"